import { FileModel } from "../../../Shared/dto/create-file-input";

export class CreateVehicleInput {
  id?: string;
  companyId?: string;
  name?: string;
  truckNumber?: string;
  chassisNumber?: string;
  plateNumber?: string;
  vehicleType?: string;
  minimumWeight?: string;
  maximumWeight?: string;
  description?: string;
  attachments?: FileModel[];
}
